import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import Profile from "./components/Dashboards/PatientDashboard/PatientProfile";
import MyAppointment from "./components/Dashboards/PatientDashboard/MyAppointment";
import MedicalDetails from "./components/Dashboards/PatientDashboard/MedicalDetails";

import Error from "./components/Error";

import AllAppointment from "./components/Dashboards/Receptionist/AllAppointment";
import OPDForm from "./components/Dashboards/Receptionist/OPDForm";
import { AnimatePresence } from "framer-motion";
import DoctorDashboard from "./components/Dashboards/Doctor/DoctorDashboard";
import Checkup from "./components/Dashboards/Doctor/Checkup";
import ForgotPassword from "./components/ForgotPassword";
import OPDList from "./components/Dashboards/Doctor/OPDList";
import EditOpd from "./components/Dashboards/Doctor/EditOpd";
import UsersList from "./components/Dashboards/Admin/AdminUsersList";
import UserList from "./components/Dashboards/Receptionist/UserList";
import OPDLists from "./components/Dashboards/Receptionist/OPDLists";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Patient from "./components/Dashboards/Comman/Patient";
import PersonalProfile from "./components/Dashboards/Comman/PersonalProfile";
import AdminDashboard from "./components/Dashboards/Admin/AdminDashboard";
import AdminOPDList from "./components/Dashboards/Admin/AdminOPDList";
import AdminSeePatient from "./components/Dashboards/Admin/AdminSeePatient";
import AdminCheckup from "./components/Dashboards/Admin/AdminCheckup";
import ReceptionistDashboard from "./components/Dashboards/Receptionist/ReceptionistDashboard";
import PatientDashboard from "./components/Dashboards/PatientDashboard/PatientDashboard";
import PatientProfile from "./components/Dashboards/PatientDashboard/PatientProfile";
import AdminReceptionistProfile from "./components/Dashboards/Admin/AdminReceptionistProfile";
import DoctorUsersList from "./components/Dashboards/Doctor/DoctorUsersList";
import DoctorOPDForm from "./components/Dashboards/Doctor/DoctorOPDForm";
import AdminUserManagement from "./components/Dashboards/Admin/AdminUserManagement";
import DropdownManager from "./components/Dashboards/Admin/DropdownManager";
import AllVisits from "./components/Dashboards/Receptionist/AllVisits";
import MonthlyAnalyticsDashboard from "./components/Dashboards/Admin/MonthlyAnalyticsDashboard";
import AppointmentForm from "./components/AppointmentForm";
import CheckupScroll from "./components/Dashboards/Doctor/CheckupScroll";
import CheckupTab from "./components/Dashboards/Doctor/CheckupTab";
import AppHome from "./AppHome";
import ExpenseManager from "./components/Dashboards/Admin/ExpenseManager";
import SuperPatientProfile from "./components/Dashboards/Doctor/SuperPatientProfile";

const App = () => {
  const { loginUser, logout } = useContext(AuthContext); // This now works because AuthProvider wraps it

  function ExternalRedirect() {
    useEffect(() => {
      window.location.href = "https://mahalaxmidentalclinic.ricecity.in/";
    }, []);

    return null; // nothing to render
  }

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<ExternalRedirect />} />
          <Route path="/home" element={<AppHome />} />

          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/appointment" element={<AppointmentForm />} />
          {/* <Route path="/profile1" element={<SuperPatientProfile patientId="69003bd1fb50af31c356d483" />} /> */}
          <Route element={<Dashboard />}>
            {loginUser?.role === "patient" && (
              <>
                <Route path="/dashboard" element={<PatientDashboard />} />
                <Route path="/dashboard/profile" element={<PatientProfile />} />
                <Route
                  path="/dashboard/appointment"
                  element={<MyAppointment />}
                />
                <Route
                  path="/dashboard/medical-details"
                  element={<MedicalDetails />}
                />
              </>
            )}
            {loginUser?.role === "receptionist" && (
              <>
                <Route path="/dashboard" element={<ReceptionistDashboard />} />
                <Route
                  path="/dashboard/appointment"
                  element={<AllAppointment />}
                />
                <Route
                  path="/dashboard/profile"
                  element={<AdminReceptionistProfile />}
                />
                <Route path="/dashboard/opd-form" element={<OPDForm />} />
                <Route path="/dashboard/patient/:id" element={<Patient />} />
                <Route path="/dashboard/user-list" element={<UserList />} />
                <Route path="/dashboard/opd-list" element={<OPDLists />} />
                <Route path="/dashboard/edit-opd/:id" element={<EditOpd />} />
                                <Route path="/dashboard/dropdown-manager" element={<DropdownManager />} />

              </>
            )}
            {loginUser?.role === "doctor" && (
              <>
                <Route path="/dashboard" element={<DoctorDashboard />} />
                <Route path="/dashboard/patient/:id" element={<Patient />} />
                <Route path="/dashboard/opd-list" element={<OPDList />} />
                <Route path="/dashboard/checkup/:id" element={<CheckupTab />} />
                 <Route path="/dashboard/checkup/t/:id" element={<CheckupTab />} />
                <Route path="/dashboard/checkup/s/:id" element={<CheckupScroll />} />
                <Route path="/dashboard/edit-opd/:id" element={<EditOpd />} />
                <Route path="/dashboard/dropdown-manager" element={<DropdownManager />} />
                <Route path="/dashboard/dropdown-manager/:category" element={<DropdownManager />} />

                <Route
                  path="/dashboard/appointment"
                  element={<AllAppointment />}
                />
                <Route
                  path="/dashboard/visits"
                  element={<AllVisits />}
                />
                <Route path="/dashboard/opd-form" element={<DoctorOPDForm />} />
                <Route
                  path="/dashboard/user-list"
                  element={<DoctorUsersList />}
                />
                <Route
                  path="/dashboard/Profile"
                  element={<PersonalProfile />}
                />
              </>
            )}
            {loginUser?.role === "admin" && (
              <>
                <Route path="/dashboard" element={<AdminDashboard />} />
                <Route path="/dashboard/expense-manager" element={<ExpenseManager />} />
                <Route
                  path="/dashboard/monthly-analytics"
                  // element={<AdminReceptionistProfile />}
                  element={<MonthlyAnalyticsDashboard />}
                />
                <Route path="/dashboard/opd-list" element={<AdminOPDList />} />
                <Route path="/dashboard/user-list" element={<UsersList />} />
                <Route path="/dashboard/all-users" element={<AdminUserManagement />} />
                 <Route path="/dashboard/dropdown-manager" element={<DropdownManager />} />
                <Route path="/dashboard/dropdown-manager/:category" element={<DropdownManager />} />
                <Route
                  path="/dashboard/patient/:id"
                  element={<AdminSeePatient />}
                />{" "}
                <Route path="/dashboard/checkup/:id" element={<AdminCheckup />} />
               
              </>
            )}
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </Router>
  );
};

const RootApp = () => (
  <AuthProvider>
    {/* Move AuthProvider here to wrap the entire App */}
    <App />
    <ToastContainer />
  </AuthProvider>
);

export default RootApp;
